import { useMemo } from 'react';
import { useAuth } from '../../authContext.js';
const useIdentityRoles = () => {
    const { identityRoles } = useAuth();
    return useMemo(() => identityRoles.reduce((aggr, item) => ({
        ...aggr,
        [item]: true,
    }), {}), [identityRoles]);
};
export default useIdentityRoles;
